import type { UndoRedoActions } from '../../../../../modernization-common/undo-redo/types';
import type { UndoableEventPayloads } from '../../../types/skeleton-template-builder.type';
import { UNDOABLE_EVENTS } from '../../../types/skeleton-template-builder.type';
import { addEdgeCommandFactory } from './add-edge-command';
import { addNodeCommandFactory } from './add-node-command';
import { clearCanvasCommandFactory } from './clear-canvas-command';
import { deleteEdgeCommandFactory } from './delete-edge-command';
import { deleteNodeCommandFactory } from './delete-node-command';
export const commandConfig: UndoRedoActions<void, UndoableEventPayloads> = {
  [UNDOABLE_EVENTS.ADD_NODE]: addNodeCommandFactory,
  [UNDOABLE_EVENTS.DELETE_NODE]: deleteNodeCommandFactory,
  [UNDOABLE_EVENTS.ADD_EDGE]: addEdgeCommandFactory,
  [UNDOABLE_EVENTS.DELETE_EDGE]: deleteEdgeCommandFactory,
  [UNDOABLE_EVENTS.CLEAR_CANVAS]: clearCanvasCommandFactory
};